const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.RolePermissionServiceSimpleClient =
  function RolePermissionServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.listRoles = this.listRoles.bind(this);
    this.listRolePermissions = this.listRolePermissions.bind(this);
  };
const methodInfo_RolePermissionService_ListRoles =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RolePermissionService/ListRoles",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListRolesRequest,
    imports.stronachgroup.first.racehorse360.ListRolesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListRolesResponse.decode
  );
module.exports.RolePermissionServiceSimpleClient.prototype.listRoles =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListRolesRequest.create(request);
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RolePermissionService/ListRoles",
      message,
      metadata || {},
      methodInfo_RolePermissionService_ListRoles
    );
  };
const methodInfo_RolePermissionService_ListRolePermissions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RolePermissionService/ListRolePermissions",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListRolePermissionsRequest,
    imports.stronachgroup.first.racehorse360.ListRolePermissionsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListRolePermissionsResponse.decode
  );
module.exports.RolePermissionServiceSimpleClient.prototype.listRolePermissions =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListRolePermissionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RolePermissionService/ListRolePermissions",
      message,
      metadata || {},
      methodInfo_RolePermissionService_ListRolePermissions
    );
  };
